import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=2bdbdc8f&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdbdc8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bdbdc8f')) {
      api.createRecord('2bdbdc8f', component.options)
    } else {
      api.reload('2bdbdc8f', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=2bdbdc8f&scoped=true&", function () {
      api.rerender('2bdbdc8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N9BvJYRX6gNs/JS/comp/Accordion.vue"
export default component.exports